import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import EndPoints from "../../Api/Endpoints";

export const fetchCategorynData = createAsyncThunk("api/category", async () => {
  const token = localStorage.getItem("other");
  const response = await fetch(EndPoints.PRISM_GET_CATEGORY_LIST, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();
  return data;
});

const categorySlice = createSlice({
  name: "category",
  initialState: {
    categorydata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategorynData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategorynData.fulfilled, (state, action) => {
        state.loading = false;
        state.categorydata = action.payload?.data || [];
      })
      .addCase(fetchCategorynData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default categorySlice.reducer;